<template>
    <div class="list-info"><span>{{Language.say('messages.list.loading')}}</span></div>

    <div class="loading">
        <div class="list-item" v-for="n in 10" :key="n">
            <div class="container">
                <div class="checkbox">
                    <input type="checkbox">
                    <label></label>
                </div>
                <div class="content">
                    <div class="message">
                        <div class="from"></div>
                        <div class="subject"></div>
                    </div>
                    <div class="meta">
                        <div class="datetime"></div>
                        <div class="flags">
                            <span class="flag">
                                <i class="fas fa-bookmark"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language      from '@/js/Shared/Language/Language.js';
</script>
